import o from "./index.ce.vue2.js";
import t from "./index.ce.vue3.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ r(o, [["styles", [t]]]);
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/house-type-edit-dialog/index.ce.vue.js
// module id = 1300
// module chunks = 67